// extracted by mini-css-extract-plugin
var _1 = "SNw0R6BoGg4na_aiz9Vg";
export { _1 as "pointer" }
